import { Deserializable } from '../../deserializable';

/**
 * Banner Response DTO used to interact with backend
 */
export class BannerResponseDTO extends Deserializable {
  /**
   * @constructor
   */
  constructor(
    public title: string,
    public description: string,
    public buttonName: string,
    public url: string,
    public showBanner: boolean,
    public startDate: string,
    public endDate: string
  ) {
    super();
  }
}
